export default {
  practiceInfo: {}
}
